import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Root, Icon, Text } from './Rule.styles';

var Rule = function Rule(_ref) {
  var text = _ref.text,
      enabled = _ref.enabled,
      testId = _ref.testId;
  return _jsxs(Root, Object.assign({
    "data-testid": testId
  }, {
    children: [_jsx(Icon, {
      className: enabled ? 'enabled' : undefined
    }), _jsx(Text, Object.assign({
      className: enabled ? 'enabled' : undefined
    }, {
      children: text
    }))]
  }));
};

export default Rule;